import { transactionService } from '@/utils/request'

// 结算中心相关接口

// 结算中心-结算管理-列表
export function getStatementListRoot (params) {
  return transactionService({
    url: 'statement/listRoot',
    method: 'get',
    params: params
  })
}

// 结算中心-审核通过
export function statementAuditPass (id) {
  return transactionService({
    url: `statement/auditPass?statementId=${id}`,
    method: 'post'
  })
}

// 结算中心-结算
export function statementPay (params) {
  return transactionService({
    url: `statement/pay?statementId=${params.statementId}&statementAccountId=${params.statementAccountId}`,
    method: 'post'
  })
}

// 结算中心-结算账号-列表
export function getStatementAccountList (params) {
  return transactionService({
    url: 'statementAccount/list',
    method: 'get',
    params: params
  })
}

// 结算中心-结算账单-列表
export function getStatementList (params) {
  return transactionService({
    url: 'statement/list',
    method: 'get',
    params: params
  })
}

// 结算中心-查看-历史
export function getStatementHistory (id) {
  return transactionService({
    url: `statementHistory/list?statementId=${id}`,
    method: 'get'
  })
}

// 结算中心-查看-订单
export function getStatementOrderList (params) {
  return transactionService({
    url: 'statement/orderList',
    method: 'get',
    params: params
  })
}

// 根据店铺ID获取结算账号id
export function getStatementAccountListById (id) {
  return transactionService({
    url: `statementAccount/listById?accountId=${id}`,
    method: 'get'
  })
}

// 店铺管理详情
export function getAccountShopDetail (id) {
  return transactionService({
    url: `account/getById?accountId=${id}`,
    method: 'get'
  })
}

// 结算中心-结算账号-新增或修改
export function saveOrUpdateStatementAccount (data) {
  return transactionService({
    url: 'statementAccount/saveOrUpdate',
    method: 'post',
    data: data
  })
}

// 通过微信code获取微信用户信息
export function getWxUserInfoByCode (code) {
  return transactionService({
    url: `wechatAuth/userInfo?code=${code}`,
    method: 'get'
  })
}
